import { Star, StarBorder } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';

import s from './FavoriteButton.module.scss';

type Props = {
  isFavorite: boolean;
  onToggle: () => void;
};

/** Звёздочка «в избранное» в шапке очереди и доски */
const FavoriteButton: React.FC<Props> = ({ isFavorite, onToggle }) => {
  // Анимация только по клику: при открытии страницы отмеченная звезда не прыгает
  const [isToggled, setIsToggled] = useState(false);
  const title = isFavorite ? 'Убрать из избранного' : 'Добавить в избранное';

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        aria-label={title}
        aria-pressed={isFavorite}
        onClick={() => {
          setIsToggled(true);
          onToggle();
        }}
      >
        {isFavorite ? (
          <Star
            fontSize="small"
            className={isToggled ? s.star_pop : undefined}
            sx={{ color: 'var(--info-color)' }}
          />
        ) : (
          <StarBorder fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export { FavoriteButton };
